import { z } from 'zod'

/** Ошибка AZS API: { error: "текст" }. */
export const azsErrorSchema = z.object({ error: z.string() })

/** Ошибка в обёртке backend2.0. */
export const apiErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
})

/** Обёртка ответа backend2.0: { success, data?, error? }. AZS API её не использует. */
export const envelopeSchema = z.object({
  success: z.boolean(),
  data: z.unknown().optional(),
  error: apiErrorSchema.optional(),
})

/**
 * Значение показателя как в internal_api.Value: ok — реальное число (ноль тоже), no_data — за период
 * ничего не приходило, unavailable — нет пригодного текущего значения. value есть только при ok.
 * Незнакомый статус считаем unavailable, чтобы не показать число там, где данных нет (ТЗ п. 8).
 */
export const VALUE_STATUSES = ['ok', 'no_data', 'unavailable'] as const
export type ValueStatus = (typeof VALUE_STATUSES)[number]
const isValueStatus = (value: string): value is ValueStatus =>
  (VALUE_STATUSES as readonly string[]).includes(value)

export const valueStatusSchema = z
  .string()
  .transform((value): ValueStatus => (isValueStatus(value) ? value : 'unavailable'))

export const apiValueSchema = z.object({
  status: valueStatusSchema,
  value: z.number().nullable().optional(),
  updated_at: z.string().nullable().optional(),
})
export type ApiValue = z.infer<typeof apiValueSchema>

/**
 * Строковое состояние как в internal_api.State (например, presence кассы): те же статусы, что у Value,
 * но value — строка, и есть она только при ok.
 */
export const apiStateSchema = z.object({
  status: valueStatusSchema,
  value: z.string().nullable().optional(),
  updated_at: z.string().nullable().optional(),
})
export type ApiState = z.infer<typeof apiStateSchema>

/** Число показателя, если оно есть: только при status = ok (ТЗ п. 8 — ноль это значение, а не пустота). */
export const apiValueNumber = (value: ApiValue | undefined): number | undefined =>
  value?.status === 'ok' && value.value != null ? value.value : undefined

/** Шаг бакетов ряда, который выбрал бэкенд под период (ТЗ п. 3.2): час для дня, день для недели и месяца, месяц для года. */
export const BUCKET_SIZES = ['hour', 'day', 'month'] as const
export type BucketSize = (typeof BUCKET_SIZES)[number]

/** Период ответа как в internal_api.PeriodResponse: фактические границы в поясе станции и шаг бакетов. */
export const periodResponseSchema = z.object({
  from: z.string(),
  to: z.string(),
  bucket_size: z
    .string()
    .transform((value): BucketSize =>
      (BUCKET_SIZES as readonly string[]).includes(value) ? (value as BucketSize) : 'day',
    ),
})
export type PeriodResponse = z.infer<typeof periodResponseSchema>
